@if (shouldDisplayStickyFooterSearch == true) {
  <div class="fixed-bottom">
    <ng-container *ngTemplateOutlet="searchbarTemplate"></ng-container>
  </div>
}

<ng-template #searchbarTemplate>
  <div class="searchbar d-flex">
    <input #searchBarInput class="m-2" type="search" [(ngModel)]="searchTerm" i18n-placeholder="@@StickyFooterMobileSearchPlaceholder" placeholder="Search" (onclick)="searchOnClick()" (keydown)="searchInputKeydown($event)" />

    <button class="btn btn-secondary" (click)="search()">
      <i class="bi bi-search"></i>
    </button>
  </div>
</ng-template>
